import axios from "../../axiosDod.js";
import { PANEL_API_URL, PANELS } from "../../config/panels";

const getDodUsers = async ({ commit }, data) => {
  const params = {};
  const { search, role } = data;
  if (search) {
    params.search = search;
  }
  if (role) {
    params.role = role;
  }
  try {
    const dodUsersList = await axios.get(`users`, { params });
    commit("SET_DOD_USERS_LIST", dodUsersList.data);
    return dodUsersList.data;
  } catch (error) {
    console.log(error);
  }
};

const getDodUserByPhoneNumber = async ({ commit }, data) => {
  const { phone } = data;
  try {
    const response = await axios.get(`users/phone/${phone}`);
    commit("SET_DOD_USER", response.data);
    return response.data;
  } catch (error) {
    commit("SET_DOD_USER", null);
    console.log(error);
  }
};

// Profil opiekuna z backendu PA POD. Wolane z karty pracownika w panelu GLOWNYM,
// gdzie interceptor axiosDod nie celuje w POD - stad jawny baseURL instancji POD.
const getPodUserByPhoneNumber = async ({ commit }, data) => {
  const { phone } = data;
  try {
    const response = await axios.get(`users/phone/${phone}`, {
      baseURL: PANEL_API_URL[PANELS.POD],
    });
    commit("SET_POD_USER", response.data);
    return response.data;
  } catch (error) {
    commit("SET_POD_USER", null);
    console.log(error);
  }
};

export default {
  getDodUsers,
  getDodUserByPhoneNumber,
  getPodUserByPhoneNumber,
};
